import { ProductCardSkeleton } from "./productCardSkeleton";
import "react-loading-skeleton/dist/skeleton.css";
export const SuggestionProductSkeleton = () => {
  return (
    <section className="proSection relatedProduct-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-lg-12">
            <div className="subcategory-title">
              <h4>Suggested Products</h4>
            </div>
          </div>
        </div>
        <div className="row row-spacing">
          {Array.from({ length: 4 }).map((_, index) => (
            <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-4" key={index}>
              <ProductCardSkeleton />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
